import * as go from 'gojs';
import { nodeRotateAdornmentTemplate } from './rotateAdornment';
import {
  HoverAdornment,
  SelectionAdornment,
} from '../Panels/addAndSplitAdornmentPanels';
import type { AddSplitBaseNodeData } from 'gojs/types';
import {
  handleFreePortArrowSelectionChanged,
  hideFreePortHoverArrows,
  showFreePortHoverArrows,
} from './freePortHoverArrows';

const $ = go.GraphObject.make;

const getStandardAngle = (angle: number) => {
  if (angle >= 45 && angle < 135) return 90;
  else if (angle >= 135 && angle < 225) return 180;
  else if (angle >= 225 && angle < 315) return 270;
  else return 0;
};

export const Template = (
  panels: (go.Panel | go.Shape)[],
  getImage: (node: any) => string,
) =>
  $(
    go.Node,
    'Spot',
    {
      rotatable: true,
      rotateObjectName: 'PIC',
      locationSpot: go.Spot.Center,
      locationObjectName: 'SHAPE',
      rotateAdornmentTemplate: nodeRotateAdornmentTemplate,
      selectionObjectName: 'SHAPE',
      selectionAdornmentTemplate: SelectionAdornment,
      mouseEnter: (e, obj) => {
        HoverAdornment.adornedObject = obj.part;
        if (obj.part) obj.part.addAdornment('mouseHover', HoverAdornment);
        showFreePortHoverArrows(obj.part as go.Node);
      },
      mouseLeave: (e, obj) => {
        obj.part?.removeAdornment('mouseHover');
        hideFreePortHoverArrows(obj.part as go.Node);
      },
      selectionChanged: handleFreePortArrowSelectionChanged,
    },
    new go.Binding('isSelected', 'selected'),
    new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(
      go.Point.stringify,
    ),
    $(
      go.Panel,
      'Spot',
      {
        name: 'SHAPE',
      },
      $(
        go.Picture,
        {
          name: 'PIC',
          stretch: go.GraphObject.Fill,
          maxSize: new go.Size(32, 32),
          isPanelMain: true,
        },
        new go.Binding('source', '', getImage),
        new go.Binding(
          'flip',
          'mirrored',
          (mirrored: AddSplitBaseNodeData['mirrored']) => {
            return mirrored
              ? go.GraphObject.FlipHorizontal
              : go.GraphObject.None;
          },
        ),
        new go.Binding(
          'angle',
          'angle',
          (angle: AddSplitBaseNodeData['angle']) => getStandardAngle(angle),
        ).makeTwoWay(),
      ),
    ),
    ...panels,
  );
